module.exports = __webpack_public_path__ + "static/media/our_vision.979045d4.png";